import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Hidden } from "@material-ui/core";
import { ErrorLoginPageForm } from "./ErrorLoginPageForm";
import { TextoEntrar } from "./TextoEntrar";
import LoginForm from "./login-form/LoginForm";
import Typography from "@material-ui/core/Typography";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  loginContainer: {
    display: "flex",
    flexDirection: "column",
  },
  login: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: theme.spacing(36),
    paddingTop: theme.spacing(16),
    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(6),
      paddingLeft: theme.spacing(0),
      alignItems: "center",
    },
  },
  textContainer: {
    marginTop: theme.spacing(12),
  },
}));

export function LoginPageForm() {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Grid container className={classes.loginContainer}>
      <Grid item className={classes.login}>
        <TextoEntrar />
        <LoginForm />
        <Hidden mdDown>
          <Grid className={classes.textContainer}>
            <Typography>{intl.formatMessage({ id: "login.info_text_1" })}</Typography>
            <Typography>{intl.formatMessage({ id: "login.info_text_2" })}</Typography>
            <Typography>{intl.formatMessage({ id: "login.info_text_3" })}</Typography>
            <Typography>{intl.formatMessage({ id: "login.info_text_4" })}</Typography>
            <Typography>{intl.formatMessage({ id: "login.info_text_5" })}</Typography>
          </Grid>
        </Hidden>
      </Grid>
      <Grid item>
        <ErrorLoginPageForm />
      </Grid>
    </Grid>
  );
}
